import type { EntryType } from "services/yandexSDK"

const inc = (value: number) => value + 1

export type IsRankChanged = (arr: Array<EntryType>, currentIndex: number) => boolean

export const isRankChanged: IsRankChanged = (arr, currentIndex) => {
  return currentIndex < arr.length-1 && arr[inc(currentIndex)].rank !== inc(arr[currentIndex].rank)
}
